import moment from 'moment';

import SEGMENT_EVENTS from 'constants/segmentEvents';

function Ctrl($scope, imgix, favoritesService, tracking) {
  if ($scope.placeholder) return;

  $scope.isFavorited = false;
  $scope.disableFavoriting = true;

  favoritesService.isFavorite(favoritesService.TYPES.EVENT, $scope.event.id)
    .then(favorited => {
      $scope.isFavorited = favorited;
      $scope.disableFavoriting = false;
    });

  $scope.imgix = function(src) {
    const options = {
      width: 360,
      height: 420
    };

    try {
      return imgix.url(src, options);
    } catch (err) {
      return null;
    }
  };

  $scope.favoriteEvent = function(event) {
    $scope.disableFavoriting = true;

    const func = ($scope.isFavorited) ? favoritesService.removeFavorite : favoritesService.addFavorite;
    const increment = ($scope.isFavorited) ? -1 : 1;

    func(favoritesService.TYPES.EVENT, event.id)
      .then(() => {
        event.favoriteCount += increment;

        $scope.isFavorited = !($scope.isFavorited);

        const eventName = ($scope.isFavorited) ? SEGMENT_EVENTS.FavoritedEvent : SEGMENT_EVENTS.UnfavoritedEvent;

        tracking.trackEvent(eventName, {
          eventId: $scope.event.id,
          eventName: $scope.event.name
        });

      })
      .finally(() => {
        $scope.disableFavoriting = false;
      });
  };

  $scope.opensAt = function(event) {
    return moment.utc(event.date).format('MMM DD, YYYY');
  };
}

Ctrl.$inject = [
  '$scope',
  'jsSdk.imgix',
  'favoritesService',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/directives/eventCard/controller.js